module.exports = `${require.publicPath}download (3).42418363.zip`;